import { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';

export function* logError(message: string, context: unknown): SagaIterator {
    yield call(console.error, `ESTM Levo: ${message}`, context);
}
